import { IWarehouse, IAddress } from 'src/model/productdetails.model';
import LocationModel from 'src/model/location.model';
import env from 'src/shared/env';

export const linkLocationsToWarehouses = (
  warehouses: IWarehouse[],
  locations: LocationModel[]
): any[] => {
  const list: any[] = [];
  if (locations) {
    locations.forEach(location => {
      warehouses.forEach(warehouse => {
        if (
          warehouse.warehouseCode === location.code &&
          warehouse.description !== 'Supplier Quantity'
        ) {
          list.push({ ...warehouse, ...location });
        }
      });
    });
  } else {
    warehouses.forEach(warehouse => {
      if (warehouse.description !== 'Supplier Quantity') {
        list.push({ ...warehouse });
      }
    });
  }
  return list;
};

export const getShipFromInfo = (
  warehouses: IWarehouse[],
  locations: LocationModel[]
): {
  shipFrom: string;
  defaultWarehouse: any;
  noPickUpList: any[];
  pickUpList: any[];
} => {
  let desc = 'No warehouses available.';
  let defaultWarehouseDescription = '';
  let defaultWarehouseCode = '';
  let defaultWarehouse: any = {};
  let firstLocationWithStock = '';
  let firstLocationWithStockCode = '';
  const list: any[] = linkLocationsToWarehouses(warehouses, locations);
  const noPickUpList: any[] = [];
  list.forEach(element => {
    if (!element.pickUpOnly) {
      noPickUpList.push(element);
    }
  });
  list.forEach(warehouse => {
    if (warehouse.warehouseCode && warehouse.default) {
      defaultWarehouse = warehouse;
      if (warehouse.quantity > 0) {
        defaultWarehouseDescription = warehouse.description;
        defaultWarehouseCode = warehouse.warehouseCode;
      }
    }
    if (warehouse.warehouseCode && warehouse.quantity > 0) {
      firstLocationWithStock = warehouse.description;
      firstLocationWithStockCode = warehouse.warehouseCode;
    }
  });

  if (defaultWarehouseDescription) {
    desc = defaultWarehouseDescription;
  } else {
    desc = firstLocationWithStock;
  }
  return {
    shipFrom: desc,
    defaultWarehouse,
    noPickUpList: env.REACT_APP_BASE_ENVIRONMENT !== 'CA' ? noPickUpList : list,
    pickUpList: list
  };
};

export const getSupplierQuantity = (warehouses: IWarehouse[]): number => {
  let quantity = 0;
  if (warehouses) {
    warehouses.forEach(warehouse => {
      if (warehouse && warehouse.description === 'Supplier Quantity') {
        quantity = warehouse.quantity;
      }
    });
  }
  return quantity;
};

export const formatAddress = (address: IAddress) => {
  return address
    ? `${address.line1 ? `${address.line1.toLocaleLowerCase()}, ` : ''}${
        address.line2 ? `${address.line2.toLocaleLowerCase()}, ` : ''
      }${address.line3 ? `${address.line3.toLocaleLowerCase()}, ` : ''}${
        address.line4 ? `${address.line4.toLocaleLowerCase()}, ` : ''
      }${address.stateCode ? `${address.stateCode} ` : ''}${
        address.postalCode ? `${address.postalCode}` : ''
      }`
    : '';
};

export const getPickUpInfo = (
  warehouses: IWarehouse[]
): { location: string; pickUpCode: string } => {
  let pickUp = false;
  let pickUpCode = '';
  let location = '';
  if (warehouses) {
    warehouses.forEach(warehouse => {
      if (warehouse.warehouseCode && !pickUp) {
        const str = warehouse.description;
        const n = str.search(' PICK UP ONLY');
        if (n >= 0 && warehouse.quantity > 0) {
          location = str.slice(0, n + 1);
          pickUpCode = warehouse.warehouseCode;
          pickUp = true;
        }
      }
    });
  }
  return { location, pickUpCode };
};
